import {
   faBold,
   faChevronDown,
   faCode,
   faIndent,
   faItalic,
   faLink,
   faListOl,
   faListUl,
   faOutdent,
   faParagraph,
   faRedo,
   faUndo,
   faVideo,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { _js } from '@ifixit/utils/localize';
import { cn } from '@ifixit/ui/lib/utils';
import type { ReactElement, ReactNode } from 'react';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapButton, tiptapButtonClassName } from '../components/TiptapButton';
import { TiptapMenubar } from '../components/TiptapMenubar';

const noop = () => {};

const DisabledButton = ({ icon, title }: { icon: ReactElement<any>; title: string }) => (
   <TiptapButton isDisabled onClick={noop} icon={icon} title={title} />
);

/**
 * Static twin of GuideIntroMenuBar for wikitext source mode, where no Tiptap
 * editor exists (source mode never mounts Tiptap so unparseable documents
 * can't crash the page, and the live buttons need an editor instance to
 * render). Keep the controls in sync with GuideIntroMenuBar — this file
 * stays free of Tiptap imports so it can ship in the eager bundle.
 */
export const GuideIntroMenuBarDisabled = ({ menubarEnd }: { menubarEnd?: ReactNode }) => (
   <TiptapMenubar menubarEnd={menubarEnd}>
      <DisabledButton icon={<FontAwesomeIcon icon={faBold} />} title={_js('Bold')} />
      <DisabledButton icon={<FontAwesomeIcon icon={faItalic} />} title={_js('Italic')} />
      <DisabledButton icon={<FontAwesomeIcon icon={faCode} />} title={_js('Insert code')} />
      <DisabledButton icon={<FontAwesomeIcon icon={faLink} />} title={_js('Insert a link')} />
      <MenuSeparator />
      <button
         type="button"
         disabled
         aria-label={_js('Text style')}
         className={cn(tiptapButtonClassName, 'p-1')}
      >
         <span className="inline-flex items-center gap-[7px]">
            <FontAwesomeIcon icon={faParagraph} />
            <FontAwesomeIcon icon={faChevronDown} />
         </span>
      </button>
      <MenuSeparator />
      <DisabledButton
         icon={<FontAwesomeIcon icon={faListUl} />}
         title={_js('Add a bulleted list')}
      />
      <DisabledButton
         icon={<FontAwesomeIcon icon={faListOl} />}
         title={_js('Add a numbered list')}
      />
      <DisabledButton icon={<FontAwesomeIcon icon={faOutdent} />} title={_js('Decrease indent')} />
      <DisabledButton icon={<FontAwesomeIcon icon={faIndent} />} title={_js('Increase indent')} />
      <MenuSeparator />
      <DisabledButton
         icon={<FontAwesomeIcon icon={faVideo} />}
         title={_js('Insert a YouTube or Vimeo Video')}
      />
      <MenuSeparator />
      <DisabledButton icon={<FontAwesomeIcon icon={faUndo} />} title={_js('Undo')} />
      <DisabledButton icon={<FontAwesomeIcon icon={faRedo} />} title={_js('Redo')} />
   </TiptapMenubar>
);
